var _a;
import { Config, env } from "./api/config";
import dayjs from "dayjs";
export var isModuleConfig = {
    Bajaj: "BAJAJ",
    Product: "PRODUCT"
};
// For bajaj isModuleConfig.BAJAJ 
// For product isModuleConfig.PRODUCT 
export var Module = isModuleConfig.Bajaj;
export var isShowCapacitorMap = env === 'dev' || env === "qa";
export var RUPEES_SYMBOL = "\u20B9";
export var WORKSHOP_SUBMENUS_ADVISOR = [{
        title: "Appointment",
        path: "/appointment"
    }, {
        title: Module === isModuleConfig.Bajaj ? "Draft Job Card" : "Vehicle Inspection",
        path: "/inspection"
    }
    // {
    //     title: "Service estimate",
    //     path: "/serviceEstimate",
    // },
    // {
    //     title: "Job card",
    //     path: "/jobCardList",
    // },
    // {
    //     title: "Job card",
    //     path: "/home",
    // },
    // {
    //     title: "Spare issues",
    //     path: "/home",
    // },
    // {
    //     title: "Work purchase order",
    //     path: "/home",
    // }
];
export var WORKSHOP_SUBMENUS_FI = [{
        title: "Final Inspector",
        path: "/finalInspection"
    }];
export var DrawerWidth = 264;
export var CloseDrawerWidth = 80;
export var HeaderWidth = 130;
export var FilterComponentWidth = 240;
export var toasterTimerSuccess = 1000;
export var toasterTimerError = 10000;
export var WalkIn = "WalkIn";
export var timerCount = 30;
export var InPerson = "InPerson";
export var FreeTextMaxLength = 250;
export var Discontinued = "Discontinued";
export var GridInitalPageSize = 10;
export var helpUrl = "https://bajajsupport.excellonsoft.com/portal/en/home";
export var PolicyNumberMaxLength = Module === isModuleConfig.Bajaj ? 25 : 100;
export var LoginOtpTimer = 180; //seconds
export var LOCAL_STORAGE_KEYS = {
    USER_LOGIN_DATA: "USER_LOGIN_DATA",
    SELECTED_DESIGNATION: "SELECTED_DESIGNATION",
    ASSIGNED_MENUS: "ASSIGNED_MENUS",
    CHANNEL_LIST: "CHANNEL_LIST",
    SELECTED_CHANNEL: "SELECTED_CHANNEL",
    SELECTED_BRANCH: "SELECTED_BRANCH",
    IDENTITY_PERSONALIZATION_LIST: "IDENTITY_PERSONALIZATION_LIST",
    MENU_FEATURE: "MENU_FEATURE",
    FILTER_FROM_DATE: "FILTER_FROM_DATE",
    FILTER_TO_DATE: "FILTER_TO_DATE",
    DASHBOARD_SELECTED_VARIANT: "DASHBOARD_SELECTED_VARIANT",
    SEARCH_INSTALLBASE_BY_TYPES_LIST: "SEARCH_INSTALLBASE_BY_TYPES_LIST",
    STATUS_LIST: "STATUS_LIST",
    VEHICLE_LIST: "VEHICLE_LIST",
    ORGANIZATION_TIMING: "ORGANIZATION_TIMING",
    MOBILE_NO_REGEX: "MOBILE_NO_REGEX",
    UCN_MAP: "UCN_MAP",
    SELECTED_SUB_MENU: "SELECTED_SUB_MENU",
    SELECTED_MENU: "SELECTED_MENU",
    DECLINED_JOB_CONFIGURATION: "DECLINED_JOB_CONFIGURATION",
    ASSIGNED_MODULEDATA: "ASSIGNED_MODULEDATA",
    USER_PROFILE_DATA: "USER_PROFILE_DATA",
    PAGING_VIEW_TYPE: "PAGING_VIEW_TYPE",
    DELAY_JOB_CARD_CONFIGURATION: "DELAY_JOB_CARD_CONFIGURATION",
    REVISED_ESTIMATE_DECLINED_JOB_CONFIGURATION: "REVISED_ESTIMATE_DECLINED_JOB_CONFIGURATION",
    ALTERNATE_PART_CONFIG: "ALTERNATE_PART_CONFIG",
    SPARE_ISSUE_MULTIPLE_DOC: "SPARE_ISSUE_MULTIPLE_DOC",
    IS_EMAIL_VERIFIED: "IS_EMAIL_VERIFIED",
    MODULE_SECTION_APPOINTMENT: "MODULE_SECTION_APPOINTMENT",
    MODULE_SECTION_ESTIMATE: "MODULE_SECTION_ESTIMATE",
    MODULE_SECTION_REVISEDESTIMATE: "MODULE_SECTION_REVISEDESTIMATE",
    MODULE_SECTION_INSPECTION: "MODULE_SECTION_INSPECTION",
    MODULE_SECTION_JOBCARD: "MODULE_SECTION_JOBCARD",
    MODULE_SECTION_FINALINSPECTION: "MODULE_SECTION_FINALINSPECTION",
    SERVICE_TYPES: 'SERVICE_TYPES',
    SELECTED_SERVICE_TYPES: 'SELECTED_SERVICE_TYPES',
    DATE_FILTER_RESTRICTION: 'DATE_FILTER_RESTRICTION',
    REPEAT_REVISIT_REASON_LIST_HEADERLEVEL: 'REPEAT_REVISIT_REASON_LIST_HEADERLEVEL',
    REPEAT_REVISIT_REASON_LIST_LINELEVEL: 'REPEAT_REVISIT_REASON_LIST_LINELEVEL',
    PRECHECK_FORM_CONTROL_LIST: "PRECHECK_FORM_CONTROL_LIST",
    APPROVAL_TYPE_LIST: "APPROVAL_TYPE_LIST",
    COMMUNICATION_TYPES_LIST: "COMMUNICATION_TYPES_LIST",
    RELATION_LIST: "RELATION_LIST",
    FILTER_APPLY: "FILTER_APPLY",
    REPEAT_REVISIT_ALERT_CONFIGURATION: "REPEAT_REVISIT_ALERT_CONFIGURATION",
    RBAC: 'RBAC',
    TRNTBikeProductCode: 'TRNTBikeProductCode',
    Tech_Pack_Exclude_Part: 'Tech_Pack_Exclude_Part',
    TECHNICAIN_LIST: 'TECHNICAIN_LIST',
    SUGGESTIONS_REQUIRED_COUNT: 'SUGGESTIONS_REQUIRED_COUNT',
    CHANNEL_SETTING_BY_KEY: 'CHANNEL_SETTING_BY_KEY'
};
export var DEFAULT_MOB_NO_REGEX = /^[1-9][0-9]{9}$/;
export var DRAFT_JC_REDIRECTS = {
    PRE_JC: "preJC",
    CREATE_JC: "createJC"
};
export var EFilterParent = /*#__PURE__*/ function (EFilterParent) {
    EFilterParent["Appointment"] = "Appointment";
    EFilterParent["Inspection"] = "Inspection";
    EFilterParent["Final Inspection"] = "Final Inspection";
    EFilterParent["Estimate"] = "Estimate";
    EFilterParent["Job Card"] = "Jobcard";
    return EFilterParent;
}({});
export var defaultMobile = "0000000000";
export var headerTitle = [{
        section: "Profile",
        paths: ['profile']
    }, {
        section: "Dashboard",
        paths: ['dashboard']
    }, {
        section: "HEADER_TITLE_VI",
        paths: ['vehicleinspectionlist', "create-inspection", "vehicleInspection-steps", "vehicleInspection-summary", "vehicleInspection-details", 'inspection', 'serviceEstimate-details-jobCard']
    }, {
        section: "Job Card",
        paths: ['jobcardlist', "create-jobCard", "jobCard-steps", "jobCard-summary", "jobCard-details", "finalInspection-taskDetails", "jobCard", 'addNewJobs']
    }, {
        section: "Appointment",
        paths: ['appointment-list', "create-appointment", "appointment-details", 'appointment', 'appoinment-tasksDetails']
    }, {
        section: "Final Inspection",
        paths: ['finalInspector', 'FinalInspection']
    }, {
        section: "Analytics & Reports",
        paths: ['reports']
    }, {
        section: "Service Estimate",
        paths: ['create-estimate', "serviceEstimate-tasksDetails", "serviceEstimate-create", "serviceEstimate-details-created", 'serviceEstimate-details', 'serviceEstimate', 'reviseEstimate-details']
    }, {
        section: "Spare issue",
        paths: ['spareIssues']
    }, {
        section: 'Journal voucher',
        paths: ['journalVoucher']
    }, {
        section: "Purchase Requisition",
        paths: ['purchaseRequisition']
    }, {
        section: 'Inter Warehouse Inward',
        paths: ['interWarehouseInward', 'createInterWarehouseInward']
    }, {
        section: 'Proprietary Warranty',
        paths: ['proprietaryWarranty', 'createProprietaryWarranty']
    }, {
        section: 'Vehicle History',
        paths: ['vehicleHistory']
    }];
export var StatusEnum = /*#__PURE__*/ function (StatusEnum) {
    StatusEnum["Reschedule"] = "Reschedule";
    StatusEnum["Closed"] = "Closed";
    StatusEnum["Open"] = "Open";
    StatusEnum["ReadyForWork"] = "ReadyForWork";
    StatusEnum["Scheduled"] = "Scheduled";
    StatusEnum["Delay"] = "Delay";
    StatusEnum["Confirmed"] = "Confirmed";
    StatusEnum["Inward"] = "Inward";
    StatusEnum["NoShow"] = "NoShow";
    StatusEnum["Cancelled"] = "Cancelled";
    StatusEnum["Error"] = "Error";
    StatusEnum["Awaiting"] = "Awaiting";
    StatusEnum["Complete"] = "Complete";
    StatusEnum["Approved"] = "Approved";
    StatusEnum["ApprovalPending"] = "Approval pending";
    StatusEnum["Converted"] = "Converted";
    StatusEnum["Created"] = "Created";
    StatusEnum["Completed"] = "Completed";
    StatusEnum["WorkCompleted"] = "WorkCompleted";
    StatusEnum["FinalInspection"] = "FinalInspection";
    StatusEnum["Invoiced"] = "Invoiced";
    StatusEnum["Delivered"] = "Delivered";
    StatusEnum["ReadyForInvoice"] = "ReadyForInvoice";
    StatusEnum["InspectionCompleted"] = "InspectionCompleted";
    StatusEnum["Rework"] = "Rework";
    StatusEnum["AwaitingForParts"] = "AwaitingForParts";
    StatusEnum["InitiateWork"] = "InitiateWork";
    StatusEnum["WorkStarted"] = "WorkStarted";
    StatusEnum["Pause"] = "Pause";
    StatusEnum["Start"] = "Started";
    StatusEnum["Started"] = "Started";
    return StatusEnum;
}({});
export var StepsAPIBody = [{
        Name: "ServiceDetails",
        IsCompleted: false,
        DisplayName: "Service details",
        Step: "Step 1"
    }, {
        Name: "CustomerComplaints",
        IsCompleted: false,
        DisplayName: "Customer complaints",
        Step: "Step 2"
    }, {
        Name: "StandardJobs",
        IsCompleted: false,
        DisplayName: "Standard jobs",
        Step: "Step 3"
    }, {
        Name: "PreCheck",
        IsCompleted: false,
        DisplayName: "Pre-check",
        Step: "Step 4"
    }, {
        Name: "RoadTest",
        IsCompleted: false,
        DisplayName: "Road test",
        Step: "Step 5"
    }, {
        Name: "AdditionalJobs",
        IsCompleted: false,
        DisplayName: "Additional Jobs",
        Step: "Step 6"
    }];
export var InspectionStepsNames = /*#__PURE__*/ function (InspectionStepsNames) {
    InspectionStepsNames["Step1_Name"] = "ServiceDetails";
    InspectionStepsNames["Step1_DisplayName"] = "Service Details";
    InspectionStepsNames["Step2_Name"] = "CustomerComplaints";
    InspectionStepsNames["Step2_DisplayName"] = "Customer Complaints";
    InspectionStepsNames["Step3_Name"] = "StandardJobs";
    InspectionStepsNames["Step3_DisplayName"] = "Standard Jobs";
    InspectionStepsNames["Step4_Name"] = "PreCheck";
    InspectionStepsNames["Step4_DisplayName"] = "Pre Check";
    InspectionStepsNames["Step5_Name"] = "RoadTest";
    InspectionStepsNames["Step5_DisplayName"] = "Road Test";
    InspectionStepsNames["Step6_Name"] = "AdditionalJobs";
    InspectionStepsNames["Step6_DisplayName"] = "Additional Jobs";
    return InspectionStepsNames;
}({});
export var StepButtonVariants = /*#__PURE__*/ function (StepButtonVariants) {
    StepButtonVariants["Next"] = "Next";
    StepButtonVariants["Previous"] = "Previous";
    return StepButtonVariants;
}({});
export var ModuleName = /*#__PURE__*/ function (ModuleName) {
    ModuleName["Service"] = "Service";
    ModuleName["Workshop"] = "Workshop";
    ModuleName["Dashboard"] = "Dashboard";
    ModuleName["FFR"] = "FFRManaulSearch";
    return ModuleName;
}({});
export var ProfileEnum = /*#__PURE__*/ function (ProfileEnum) {
    ProfileEnum["Identity"] = "Identity";
    ProfileEnum["Profile"] = "Profile";
    return ProfileEnum;
}({});
export var SearchStateE = /*#__PURE__*/ function (SearchStateE) {
    SearchStateE["toSearch"] = "toSearch";
    SearchStateE["searching"] = "searching";
    SearchStateE["searchComplete"] = "searchComplete";
    return SearchStateE;
}({});
export var ESearchResultAndRiderParentName = /*#__PURE__*/ function (ESearchResultAndRiderParentName) {
    ESearchResultAndRiderParentName["CreateInspection"] = "Create Inspection";
    ESearchResultAndRiderParentName["CreateEstimate"] = "Create Estimate";
    ESearchResultAndRiderParentName["CreateJobcard"] = "Create Jobcard";
    return ESearchResultAndRiderParentName;
}({});
export var EListCardView = /*#__PURE__*/ function (EListCardView) {
    EListCardView["Appointment"] = "Appointment";
    EListCardView["Inspection"] = "Inspection";
    EListCardView["JobCard"] = "JobCard";
    EListCardView["finalInspector"] = "finalInspector";
    EListCardView["ServiceEstimate"] = "Service Estimate";
    EListCardView["ServiceEstimateCreated"] = "Created";
    EListCardView["ServiceEstimateError"] = "Error";
    return EListCardView;
}({});
export var APISchema = /*#__PURE__*/ function (APISchema) {
    APISchema["Appointment"] = "Appointment";
    APISchema["Inspection"] = "Inspection";
    APISchema["Estimate"] = "Estimate";
    APISchema["Jobcard"] = "JobCard";
    APISchema["finalInspector"] = "finalInspector";
    APISchema["SpareIssues"] = "ProductIssue";
    APISchema["PurchaseRequisition"] = "PurchaseRequisition";
    APISchema["PurchaseProcurement"] = "PurchaseProcurement";
    APISchema["StockTransferRequisition"] = "StockTransferRequisition";
    APISchema["PDICheck"] = "PDICheck";
    return APISchema;
}({});
export var ECancelDocSystemName = /*#__PURE__*/ function (ECancelDocSystemName) {
    ECancelDocSystemName["Appointment"] = "Appointment";
    ECancelDocSystemName["Estimate"] = "Estimate";
    ECancelDocSystemName["Inspection"] = "Inspection";
    ECancelDocSystemName["JobCard"] = "JobCard";
    return ECancelDocSystemName;
}({});
export var ETaskName = /*#__PURE__*/ function (ETaskName) {
    ETaskName["PeriodicMaintenance"] = "Periodic Maintenance";
    ETaskName["StandardServices"] = "Standard Services";
    ETaskName["AdditionalJobs"] = "Additional Jobs";
    ETaskName["CustomerVoice"] = "Customer Voice";
    return ETaskName;
}({});
export var EParentModuleName = /*#__PURE__*/ function (EParentModuleName) {
    EParentModuleName["Appointment"] = "Appointment";
    EParentModuleName["Inspection"] = "Inspection";
    EParentModuleName["Jobcard"] = "Jobcard";
    EParentModuleName["finalInspector"] = "finalInspector";
    EParentModuleName["ServiceEstimate"] = "ServiceEstimate";
    EParentModuleName["RevisedServiceEstimate"] = "RevisedServiceEstimate";
    EParentModuleName["DetailServiceEstimate"] = "DetailServiceEstimate";
    EParentModuleName["SpareIssue"] = "SpareIssue";
    EParentModuleName["ProprietaryWarranty"] = "ProprietaryWarranty";
    EParentModuleName["JobCardInvoice"] = "JobCardInvoice";
    return EParentModuleName;
}({});
export var EModuleTypes = /*#__PURE__*/ function (EModuleTypes) {
    EModuleTypes["Appointment"] = "Appointment";
    EModuleTypes["Inspection"] = "Inspection";
    EModuleTypes["Jobcard"] = "JobCard";
    EModuleTypes["FinalInspection"] = "FinalInspection";
    EModuleTypes["ServiceEstimate"] = "Estimate";
    EModuleTypes["FFR"] = "FFRManaulSearch";
    return EModuleTypes;
}({});
export var EMenuNames = /*#__PURE__*/ function (EMenuNames) {
    EMenuNames["Appointment"] = "Appointment";
    EMenuNames["Inspection"] = "VehicleInspection";
    EMenuNames["Jobcard"] = "JobCard";
    EMenuNames["ServiceEstimate"] = "ServiceEstimate";
    EMenuNames["FinalInspection"] = "FinalInspection";
    return EMenuNames;
}({});
export var EJobItemType = /*#__PURE__*/ function (EJobItemType) {
    EJobItemType["Additional"] = "ADDITIONAL_JOBS";
    EJobItemType["PeriodicMaintenance"] = "PM_PARTS";
    return EJobItemType;
}({});
export var ESystemName = /*#__PURE__*/ function (ESystemName) {
    ESystemName["Appointment"] = "Appointment";
    ESystemName["Inspection"] = "Inspection";
    ESystemName["Estimate"] = "Estimate";
    ESystemName["ServiceEstimate"] = "ServiceEstimate";
    ESystemName["RevisedEstimate"] = "RevisedEstimate";
    ESystemName["Jobcard"] = "JobCard";
    ESystemName["StockAdjustment"] = "StockAdjustment";
    ESystemName["RoadTest"] = "RoadTest";
    ESystemName["CustomerVoiceToJobItem"] = "CustomerVoiceToJobItem";
    ESystemName["FinalInspection"] = "FinalInspection";
    ESystemName["CustomerVoice"] = "CustomerVoice";
    ESystemName["AssigntoFinalInspector"] = "AssigntoFinalInspector";
    ESystemName["SpareIssue"] = "SpareIssue";
    ESystemName["SpareIssueReturn"] = "SpareIssueReturn";
    ESystemName["StockTransferRequisition"] = "StockTransferRequisition";
    ESystemName["JournalVoucher"] = "JournalVoucher";
    ESystemName["StockTransfer"] = "StockTransfer";
    ESystemName["BranchToBranchRequisition"] = "BranchToBranchRequisition";
    ESystemName["WorkPurchaseOrder"] = "WorkPurchaseOrder";
    ESystemName["BranchToBranchInward"] = "BranchToBranchInward";
    ESystemName["PDICheck"] = "PDICheck";
    ESystemName["InterWarehouseRequisition"] = "InterWarehouseRequisition";
    ESystemName["InterWarehouseOutword"] = "InterWarehouseOutword";
    ESystemName["InterWarehouseInward"] = "InterWarehouseInward";
    ESystemName["BToBOutward"] = "BToBOutward";
    ESystemName["BToBInward"] = "BToBInward";
    ESystemName["PurchaseOrder"] = "PurchaseOrder";
    ESystemName["PurchaseRequisition"] = "PurchaseRequisition";
    ESystemName["WorkPurchaseInvoice"] = "WorkPurchaseInvoice";
    ESystemName["ProprietaryWarranty"] = "ProprietaryWarranty";
    ESystemName["jciReturn"] = "jciReturn";
    ESystemName["RevisedServiceEstimate"] = "RevisedServiceEstimate";
    return ESystemName;
}({});
export var fuelIndicatorMarkList_CNG_LPG = [{
        value: 0,
        label: "R"
    }, {
        value: 25,
        label: "I"
    }, {
        value: 50,
        label: "II"
    }, {
        value: 75,
        label: "III"
    }, {
        value: 100,
        label: "IIII"
    }];
export var fuelIndicatorMarkList_EV = [{
        value: 0,
        label: "0%"
    }, {
        value: 100,
        label: "100%"
    }];
export var markList = [{
        value: 0,
        label: "E"
    }, {
        value: 25,
        label: "1/4"
    }, {
        value: 50,
        label: "1/2"
    }, {
        value: 75,
        label: "3/4"
    }, {
        value: 100,
        label: "F"
    }];
export var EFaultType = /*#__PURE__*/ function (EFaultType) {
    EFaultType["Missing"] = "Missing";
    EFaultType["Damage"] = "Damage";
    EFaultType["Scratch"] = "Scratch";
    return EFaultType;
}({});
export var EMenuFeature = /*#__PURE__*/ function (EMenuFeature) {
    EMenuFeature["Reschedule"] = "Reschedule";
    EMenuFeature["Cancel"] = "Cancel";
    EMenuFeature["AssignServiceAdvisor"] = "AssignServiceAdvisor";
    EMenuFeature["ReassignServiceAdvisor"] = "ReassignServiceAdvisor";
    EMenuFeature["CreateVehicleInward"] = "CreateVehicleInward";
    EMenuFeature["CreateVehicleInspection"] = "CreateVehicleInspection";
    EMenuFeature["ViewTasksSummary"] = "ViewTaskSummaryJobCard";
    EMenuFeature["ViewServiceEstimate"] = "ViewServiceEstimateJobCard";
    EMenuFeature["CreateWPO"] = "CreateWPO";
    EMenuFeature["CreateSpareIssue"] = "CreateSpareIssue";
    EMenuFeature["AssignFinalInspector"] = "AssignFinalInspector";
    EMenuFeature["CreateJobCard"] = "CreateJobCard";
    EMenuFeature["GenerateEstimate"] = "GenerateEstimate";
    EMenuFeature["ViewEstimate"] = "ViewEstimate";
    EMenuFeature["ReassignFinalInspector"] = "ReassignFinalInspector";
    EMenuFeature["CreateNewSpareIssue"] = "CreateNewSpareIssue";
    EMenuFeature["ViewSpareIssue"] = "ViewSpareIssue";
    EMenuFeature["ChangeServiceType"] = "ChangeServiceType";
    EMenuFeature["FiViewTaskSummary"] = "ViewTaskSummary";
    EMenuFeature["FiViewServiceEstimate"] = "ViewServiceEstimate";
    return EMenuFeature;
}({});
export var EModuleSection = /*#__PURE__*/ function (EModuleSection) {
    EModuleSection["PeriodicMaintenance"] = "PERIODIC_MAINTENANCE";
    EModuleSection["RoadTest"] = "ROAD_TEST";
    EModuleSection["DeclinedJobs"] = "DECLINED_JOBS";
    EModuleSection["StandardJobs"] = "STANDARD_JOBS";
    EModuleSection["Precheck"] = "PRE_CHECK";
    EModuleSection["AdditionalJobs"] = "ADDITIONAL_JOBS";
    EModuleSection["PickUpAndDrop"] = "Pick Up And Drop";
    EModuleSection["CustomerComplaints"] = "CUSTOMER_COMPLAINT";
    EModuleSection["RoadTestAndCustomerComplaint"] = "JOB_ITEMS";
    EModuleSection["CustomerVoice"] = "CUSTOMER_VOICE";
    EModuleSection["Bay"] = "BAY";
    EModuleSection["PreviousDeclinedJobs"] = "PREVIOUS_DECLINED_JOBS";
    EModuleSection["AdvisorSuggestions"] = "Suggestion";
    EModuleSection["FutureAdvise"] = "Future_Advice";
    return EModuleSection;
}({});
export var EFinalInspectorModuleSection = /*#__PURE__*/ function (EFinalInspectorModuleSection) {
    EFinalInspectorModuleSection["RoadTest"] = "ROAD_TEST";
    EFinalInspectorModuleSection["CustomerComplaints"] = "CUSTOMER_VOICE";
    EFinalInspectorModuleSection["PeriodicMaintenance"] = "PERIODIC_MAINTENANCE";
    EFinalInspectorModuleSection["StandardJobs"] = "STANDARD_JOBS";
    EFinalInspectorModuleSection["AdditionalJobs"] = "ADDITIONAL_JOBS";
    EFinalInspectorModuleSection["StaticFIChecklist"] = "STATIC_FI_CHECKLIST";
    EFinalInspectorModuleSection["DynamicChecklist"] = "DYNAMIC_CHECKLIST";
    EFinalInspectorModuleSection["FastnerChecklist"] = "FASTNER_CHECKLIST";
    return EFinalInspectorModuleSection;
}({});
export var ESectionAttributeValue = /*#__PURE__*/ function (ESectionAttributeValue) {
    ESectionAttributeValue["ON"] = "ON";
    ESectionAttributeValue["OFF"] = "OFF";
    return ESectionAttributeValue;
}({});
export var EFIJobCardDetailKeys = /*#__PURE__*/ function (EFIJobCardDetailKeys) {
    EFIJobCardDetailKeys["ADDITIONAL_JOBS"] = "ADDITIONAL_JOBS";
    EFIJobCardDetailKeys["PERIODIC_MAINTENANCE"] = "PERIODIC_MAINTENANCE";
    EFIJobCardDetailKeys["STANDARD_JOBS"] = "STANDARD_JOBS";
    return EFIJobCardDetailKeys;
}({});
export var EFIChecklistKeys = /*#__PURE__*/ function (EFIChecklistKeys) {
    EFIChecklistKeys["StaticChecklist"] = "StaticChecklist";
    EFIChecklistKeys["DynamicChecklist"] = "DynamicChecklist";
    EFIChecklistKeys["FastnerChecklist"] = "FastnerChecklist";
    return EFIChecklistKeys;
}({});
export var EFIChecklistParent = /*#__PURE__*/ function (EFIChecklistParent) {
    EFIChecklistParent["StaticChecklist"] = "Static FI Checklist";
    EFIChecklistParent["DynamicChecklist"] = "Dynamic Checklist";
    EFIChecklistParent["FastnerChecklist"] = "Fastener Checklist";
    EFIChecklistParent["PeriodicMaintenance"] = "Periodic maintenance";
    EFIChecklistParent["StandaredJobs"] = "Standared Jobs";
    EFIChecklistParent["AdditionalJobs"] = "Additional Jobs";
    return EFIChecklistParent;
}({});
export var versionNum = {
    version: "".concat(Config.version)
};
export var EDashboardtabName = /*#__PURE__*/ function (EDashboardtabName) {
    EDashboardtabName["Appointments"] = "Appointments";
    EDashboardtabName["PreJC"] = "Pre JC";
    EDashboardtabName["DraftJC"] = "Draft JC";
    EDashboardtabName["JCOpened"] = "JC Opened";
    EDashboardtabName["ReadyForInvoice"] = "Ready For Invoice";
    EDashboardtabName["Delivered"] = "Delivered";
    EDashboardtabName["InProgress"] = "In Progress";
    EDashboardtabName["WorkCompleted"] = "Work Completed";
    EDashboardtabName["WithFI"] = "With FI";
    EDashboardtabName["AllOpen"] = "All Open";
    EDashboardtabName["Pending"] = "Pending";
    EDashboardtabName["Rework"] = "Rework";
    EDashboardtabName["Complete"] = "Complete";
    EDashboardtabName["OpenJC"] = "Open JC";
    EDashboardtabName["Estimate"] = "Estimate";
    return EDashboardtabName;
}({});
// Dashboard status start
export var appointmentsStatus = [{
        Name: 'Scheduled',
        Key: 'Scheduled'
    }, {
        Name: 'Inward',
        Key: 'Inward'
    }, {
        Name: 'NoShow',
        Key: 'NoShow'
    }, {
        Name: 'Rescheduled',
        Key: 'Rescheduled'
    }, {
        Name: 'Cancelled',
        Key: 'Cancelled'
    }, {
        Name: 'Closed',
        Key: 'Closed'
    }, {
        Name: 'Delay',
        Key: 'Delay'
    }];
export var draftJCStatus = [{
        Name: 'Open',
        Key: 'Open'
    }, {
        Name: 'Completed',
        Key: 'Completed'
    }, {
        Name: 'Cancelled',
        Key: 'Cancelled'
    }];
export var estimateStatus = [{
        Name: 'Created',
        Key: 'Created'
    }, {
        Name: 'Approved',
        Key: 'Approved'
    }, {
        Name: 'Cancelled',
        Key: 'Cancelled'
    }, {
        Name: 'Approval pending',
        Key: 'Approvalpending'
    }];
export var preJCStatus = [{
        Name: 'Pre-JC',
        Key: 'Confirmed'
    }];
export var jcOpenedStatus = [{
        Name: 'Open',
        Key: 'ReadyForWork'
    }];
export var inProgressStatus = [{
        Name: 'Work In Progress',
        Key: 'WorkStarted'
    }];
export var workCompletedStatus = [{
        Name: 'Work completed',
        Key: 'WorkCompleted'
    }];
export var withFIStatus = [{
        Name: 'Final Inspection',
        Key: 'FinalInspection'
    }, {
        Name: 'Inspection completed',
        Key: 'InspectionCompleted'
    }, {
        Name: 'Rework',
        Key: 'Rework'
    }];
export var readyForInvoiceStatus = [{
        Name: 'Ready for Invoice',
        Key: 'ReadyForInvoice'
    }];
export var deliveredStatus = [{
        Name: 'Delivered',
        Key: 'Delivered'
    }];
export var allOpenStatus = [{
        Name: 'Open',
        Key: 'ReadyForWork'
    }, {
        Name: 'Work completed',
        Key: 'WorkCompleted'
    }, {
        Name: 'Work In Progress',
        Key: 'WorkStarted'
    }, {
        Name: 'Inspection completed',
        Key: 'InspectionCompleted'
    }, {
        Name: 'Final Inspection',
        Key: 'FinalInspection'
    }, {
        Name: 'Ready for Invoice',
        Key: 'ReadyForInvoice'
    }, {
        Name: 'Rework',
        Key: 'Rework'
    }];
export var pendingStatus = [{
        Name: 'Final Inspection',
        Key: 'FinalInspection'
    }];
export var reworkStatus = [{
        Name: 'Rework',
        Key: 'Rework'
    }];
export var completeStatus = [{
        Name: 'Inspection completed',
        Key: 'InspectionCompleted'
    }];
//Dashboard status end
export var EDashboardStatusColor = /*#__PURE__*/ function (EDashboardStatusColor) {
    EDashboardStatusColor["Scheduled"] = "Scheduled";
    EDashboardStatusColor["Inward"] = "Inward";
    EDashboardStatusColor["NoShow"] = "NoShow";
    EDashboardStatusColor["Rescheduled"] = "Rescheduled";
    EDashboardStatusColor["Cancelled"] = "Cancelled";
    EDashboardStatusColor["Confirmed"] = "Confirmed";
    EDashboardStatusColor["Closed"] = "Closed";
    EDashboardStatusColor["Delay"] = "Delay";
    EDashboardStatusColor["Error"] = "Error";
    EDashboardStatusColor["Open"] = "Open";
    EDashboardStatusColor["Completed"] = "Completed";
    EDashboardStatusColor["Converted"] = "Converted";
    EDashboardStatusColor["Created"] = "Created";
    EDashboardStatusColor["Approved"] = "Approved";
    EDashboardStatusColor["ApprovalPending"] = "ApprovalPending";
    EDashboardStatusColor["Delivered"] = "Delivered";
    EDashboardStatusColor["DraftJC"] = "DraftJC";
    EDashboardStatusColor["PendingForApproval"] = "PendingForApproval";
    EDashboardStatusColor["ReadyForWork"] = "ReadyForWork";
    EDashboardStatusColor["AwaitingForParts"] = "AwaitingForParts";
    EDashboardStatusColor["InitateWork"] = "InitateWork";
    EDashboardStatusColor["WorkStarted"] = "WorkStarted";
    EDashboardStatusColor["WorkCompleted"] = "WorkCompleted";
    EDashboardStatusColor["FinalInspection"] = "FinalInspection";
    EDashboardStatusColor["InspectionCompleted"] = "InspectionCompleted";
    EDashboardStatusColor["Rework"] = "Rework";
    EDashboardStatusColor["ReadyForInvoice"] = "ReadyForInvoice";
    EDashboardStatusColor["Invoiced"] = "Invoiced";
    return EDashboardStatusColor;
}({});
export var FITaskDetailsButtonVariant = /*#__PURE__*/ function (FITaskDetailsButtonVariant) {
    FITaskDetailsButtonVariant["FinishInspection"] = "Finish Inspection";
    FITaskDetailsButtonVariant["SendBack"] = "Refer Back";
    return FITaskDetailsButtonVariant;
}({});
export var EUserRole = /*#__PURE__*/ function (EUserRole) {
    EUserRole["FinalInspector"] = "FinalInspector";
    EUserRole["ServiceAdvisor"] = "ServiceAdvisor";
    EUserRole["FloorSupervisor"] = "FloorSupervisor";
    EUserRole["TeleCaller"] = "TeleCaller";
    EUserRole["Default"] = "Default";
    return EUserRole;
}({});
export var ESABoxParent = /*#__PURE__*/ function (ESABoxParent) {
    ESABoxParent["CustomerComplaint"] = "CustomerComplaint";
    ESABoxParent["RoadTest"] = "RoadTest";
    return ESABoxParent;
}({});
var PRODUCT_JOB_CARD_STATUS_PROGRESS = [{
        Sequence: 1,
        key: "ReadyForWork",
        label: 'Ready for work',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 2,
        key: "AwaitingForParts",
        label: 'Awaiting for parts',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 3,
        key: "InitiateWork",
        label: 'Initiate work',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 4,
        key: "WorkStarted",
        label: 'Work started',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 5,
        key: "WorkCompleted",
        label: 'Work Completed',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 6,
        key: "FinalInspection",
        label: 'Final inspection',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 7,
        key: "Rework",
        label: 'Rework',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 8,
        key: "InspectionCompleted",
        label: 'Inspection completed',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 9,
        key: "ReadyForInvoice",
        label: 'Ready for invoice',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 10,
        key: "Invoiced",
        label: 'Invoiced',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 11,
        key: "Delivered",
        label: 'Delivered',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 12,
        key: "Cancelled",
        label: 'Cancelled',
        isActive: false,
        isCompleted: false
    }];
var BAJAJ_JOB_CARD_STATUS_PROGRESS = [{
        Sequence: 1,
        key: "ReadyForWork",
        label: 'Open',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 2,
        key: "WorkStarted",
        label: 'Work In Progress',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 3,
        key: "WorkCompleted",
        label: 'Work Completed',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 4,
        key: "FinalInspection",
        label: 'Final inspection',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 5,
        key: "Rework",
        label: 'Rework',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 6,
        key: "InspectionCompleted",
        label: 'Inspection completed',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 7,
        key: "ReadyForInvoice",
        label: 'Ready for invoice',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 8,
        key: "Invoiced",
        label: 'Invoiced',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 9,
        key: "Delivered",
        label: 'Delivered',
        isActive: false,
        isCompleted: false
    }, {
        Sequence: 10,
        key: "Cancelled",
        label: 'Cancelled',
        isActive: false,
        isCompleted: false
    }];
export var steps = Module === isModuleConfig.Bajaj ? BAJAJ_JOB_CARD_STATUS_PROGRESS : PRODUCT_JOB_CARD_STATUS_PROGRESS;
export var VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR_E = /*#__PURE__*/ function (VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR_E) {
    VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR_E["SCRATCH"] = "SCRATCH";
    VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR_E["DAMAGE"] = "DAMAGE";
    VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR_E["MISSING"] = "MISSING";
    return VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR_E;
}({});
export var VEHICLE_PRECHECK_IMAGE_VIEW_LEGENDS_COLOR = {
    SCRATCH: "#7D5EFA",
    DAMAGE: "#FFAB00",
    MISSING: "#F5222D"
};
export var E_VehicleConditionView = /*#__PURE__*/ function (E_VehicleConditionView) {
    E_VehicleConditionView["List"] = "List";
    E_VehicleConditionView["Image"] = "Image";
    return E_VehicleConditionView;
}({});
export var VEHICLE_PRECHECK_IMAGE_VIEW_DETAILS = {
    HEIGHT: 450,
    WIDTH: 280,
    RADIUS: 10
};
export var UCN_MAP_KEYS = /*#__PURE__*/ function (UCN_MAP_KEYS) {
    UCN_MAP_KEYS["UCN_CODE_TRANSACTION_TYPE"] = "UCN_CODE_TRANSACTION_TYPE";
    UCN_MAP_KEYS["UCN_CODE_SOURCE"] = "UCN_CODE_SOURCE";
    UCN_MAP_KEYS["UCN_CODE_OPTIONS"] = "UCN_CODE_OPTIONS";
    UCN_MAP_KEYS["UCN_CODE_SERVICE_TYPE"] = "UCN_CODE_SERVICE_TYPE";
    UCN_MAP_KEYS["UCNSenderName"] = "UCNSenderName";
    UCN_MAP_KEYS["IsSendUCNDisabled"] = "IsSendUCNDisabled";
    return UCN_MAP_KEYS;
}({});
// const newDocumentMenuList = ["New Appointment", "New Vehicle Inspection",];
export var E_NEW_DOCUMENT_MENU_LIST = /*#__PURE__*/ function (E_NEW_DOCUMENT_MENU_LIST) {
    E_NEW_DOCUMENT_MENU_LIST["NEW_APPOINTMENT"] = "New Appointment";
    E_NEW_DOCUMENT_MENU_LIST["NEW_INSPECTION"] = "New Vehicle Inspection";
    E_NEW_DOCUMENT_MENU_LIST["NEW_ESTIMATE"] = "New Service Estimate";
    return E_NEW_DOCUMENT_MENU_LIST;
}({});
export var dayArray = [{
        Date: "01",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Wed",
        Year: "2024",
        FullDate: '01 May, 2024'
    }, {
        Date: "02",
        Month: "May",
        AvailableSlots: 10,
        TotalSlots: 20,
        WeekdayShort: "Thu",
        Year: "2024",
        FullDate: '02 May, 2024'
    }, {
        Date: "03",
        Month: "May",
        AvailableSlots: 3,
        TotalSlots: 20,
        WeekdayShort: "Fri",
        Year: "2024",
        FullDate: '03 May, 2024'
    }, {
        Date: "04",
        Month: "May",
        AvailableSlots: 12,
        TotalSlots: 20,
        WeekdayShort: "Sat",
        Year: "2024",
        FullDate: '04 May, 2024'
    }, {
        Date: "05",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Sun",
        Year: "2024",
        FullDate: '05 May, 2024'
    }, {
        Date: "06",
        Month: "May",
        AvailableSlots: 25,
        TotalSlots: 20,
        WeekdayShort: "Mon",
        Year: "2024",
        FullDate: '06 May, 2024'
    }, {
        Date: "07",
        Month: "May",
        AvailableSlots: 10,
        TotalSlots: 20,
        WeekdayShort: "Tue",
        Year: "2024",
        FullDate: '07 May, 2024'
    }, {
        Date: "08",
        Month: "May",
        AvailableSlots: 8,
        TotalSlots: 20,
        WeekdayShort: "Wed",
        Year: "2024",
        FullDate: '08 May, 2024'
    }, {
        Date: "09",
        Month: "May",
        AvailableSlots: 5,
        TotalSlots: 20,
        WeekdayShort: "Thu",
        Year: "2024",
        FullDate: '09 May, 2024'
    }, {
        Date: "10",
        Month: "May",
        AvailableSlots: 4,
        TotalSlots: 20,
        WeekdayShort: "Fri",
        Year: "2024",
        FullDate: '10 May, 2024'
    }, {
        Date: "11",
        Month: "May",
        AvailableSlots: 14,
        TotalSlots: 20,
        WeekdayShort: "Sat",
        Year: "2024",
        FullDate: '11 May, 2024'
    }, {
        Date: "12",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Sun",
        Year: "2024",
        FullDate: '12 May, 2024'
    }, {
        Date: "13",
        Month: "May",
        AvailableSlots: 20,
        TotalSlots: 20,
        WeekdayShort: "Mon",
        Year: "2024",
        FullDate: '13 May, 2024'
    }, {
        Date: "14",
        Month: "May",
        AvailableSlots: 15,
        TotalSlots: 20,
        WeekdayShort: "Tue",
        Year: "2024",
        FullDate: '14 May, 2024'
    }, {
        Date: "15",
        Month: "May",
        AvailableSlots: 7,
        TotalSlots: 20,
        WeekdayShort: "Wed",
        Year: "2024",
        FullDate: '15 May, 2024'
    }, {
        Date: "16",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Thu",
        Year: "2024",
        FullDate: '16 May, 2024'
    }, {
        Date: "17",
        Month: "May",
        AvailableSlots: 3,
        TotalSlots: 20,
        WeekdayShort: "Fri",
        Year: "2024",
        FullDate: '17 May, 2024'
    }, {
        Date: "18",
        Month: "May",
        AvailableSlots: 12,
        TotalSlots: 20,
        WeekdayShort: "Sat",
        Year: "2024",
        FullDate: '18 May, 2024'
    }, {
        Date: "19",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Sun",
        Year: "2024",
        FullDate: '19 May, 2024'
    }, {
        Date: "20",
        Month: "May",
        AvailableSlots: 25,
        TotalSlots: 20,
        WeekdayShort: "Mon",
        Year: "2024",
        FullDate: '20 May, 2024'
    }, {
        Date: "21",
        Month: "May",
        AvailableSlots: 10,
        TotalSlots: 20,
        WeekdayShort: "Tue",
        Year: "2024",
        FullDate: '21 May, 2024'
    }, {
        Date: "22",
        Month: "May",
        AvailableSlots: 8,
        TotalSlots: 20,
        WeekdayShort: "Wed",
        Year: "2024",
        FullDate: '22 May, 2024'
    }, {
        Date: "23",
        Month: "May",
        AvailableSlots: 5,
        TotalSlots: 20,
        WeekdayShort: "Thu",
        Year: "2024",
        FullDate: '23 May, 2024'
    }, {
        Date: "24",
        Month: "May",
        AvailableSlots: 4,
        TotalSlots: 20,
        WeekdayShort: "Fri",
        Year: "2024",
        FullDate: '24 May, 2024'
    }, {
        Date: "25",
        Month: "May",
        AvailableSlots: 14,
        TotalSlots: 20,
        WeekdayShort: "Sat",
        Year: "2024",
        FullDate: '25 May, 2024'
    }, {
        Date: "26",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Sun",
        Year: "2024",
        FullDate: '26 May, 2024'
    }, {
        Date: "27",
        Month: "May",
        AvailableSlots: 20,
        TotalSlots: 20,
        WeekdayShort: "Mon",
        Year: "2024",
        FullDate: '27 May, 2024'
    }, {
        Date: "28",
        Month: "May",
        AvailableSlots: 15,
        TotalSlots: 20,
        WeekdayShort: "Tue",
        Year: "2024",
        FullDate: '28 May, 2024'
    }, {
        Date: "29",
        Month: "May",
        AvailableSlots: 7,
        TotalSlots: 20,
        WeekdayShort: "Wed",
        Year: "2024",
        FullDate: '29 May, 2024'
    }, {
        Date: "30",
        Month: "May",
        AvailableSlots: 6,
        TotalSlots: 20,
        WeekdayShort: "Thu",
        Year: "2024",
        FullDate: '30 May, 2024'
    }];
export var FONT_SIZES = {
    F_14_W_600: {
        fontSize: 14,
        fontWeight: 600
    },
    F_30_W_900: {
        fontSize: 30,
        fontWeight: 900
    }
};
// export const FONT_SIZES = {
//     fontSize: 14,
//     fontWeight: 600
// }
export var ElabelStyling = {
    fontSize: "15px",
    Padding: "8px",
    color: '#8593A3',
    fontWeight: 500
};
export var AlternatePartRelations = /*#__PURE__*/ function (AlternatePartRelations) {
    AlternatePartRelations["OneWay"] = "AlternateProduct(OneWay)";
    AlternatePartRelations["TwoWay"] = "AlternateProduct(TwoWay)";
    AlternatePartRelations["Superseds"] = "AlternateProduct(Superseds)";
    return AlternatePartRelations;
}({});
export var ALTERNATE_PART_RELATIONSHIP_LABEL_MAP = (_a = {},
    _a[AlternatePartRelations.OneWay] = "One way -  alternate part.",
    _a[AlternatePartRelations.TwoWay] = "Two way -  alternate part.",
    _a[AlternatePartRelations.Superseds] = "",
    _a);
export var JC_ALERT_TYPES = /*#__PURE__*/ function (JC_ALERT_TYPES) {
    JC_ALERT_TYPES["Repeat"] = "Repeat";
    JC_ALERT_TYPES["Revisit"] = "Revisit";
    JC_ALERT_TYPES["Recall"] = "Recall";
    JC_ALERT_TYPES["Delayed"] = "Delayed";
    JC_ALERT_TYPES["HexFile"] = "Hex file";
    return JC_ALERT_TYPES;
}({});
export var JC_ALERT_CONFIG_LEVELS = /*#__PURE__*/ function (JC_ALERT_CONFIG_LEVELS) {
    JC_ALERT_CONFIG_LEVELS["Header"] = "Header";
    JC_ALERT_CONFIG_LEVELS["Line"] = "Line";
    JC_ALERT_CONFIG_LEVELS["Both"] = "Both";
    return JC_ALERT_CONFIG_LEVELS;
}({});
export var SPARE_ISSUE_ENUM = /*#__PURE__*/ function (SPARE_ISSUE_ENUM) {
    SPARE_ISSUE_ENUM["MultipleDocument"] = "MultipleDocument";
    return SPARE_ISSUE_ENUM;
}({});
export var SEARCH_TYPES_ENUM = /*#__PURE__*/ function (SEARCH_TYPES_ENUM) {
    SEARCH_TYPES_ENUM["FinalInspection"] = "FI";
    return SEARCH_TYPES_ENUM;
}({});
export var RepeatAlertConfigAdditionalDefination = /*#__PURE__*/ function (RepeatAlertConfigAdditionalDefination) {
    RepeatAlertConfigAdditionalDefination["SameParts"] = "SameParts";
    RepeatAlertConfigAdditionalDefination["SameLabour"] = "SameLabour";
    RepeatAlertConfigAdditionalDefination["SameCustomerComplaint"] = "SameCustomerComplaint";
    RepeatAlertConfigAdditionalDefination["SameLineServiceTypePart"] = "SameLineServiceType(Part)";
    RepeatAlertConfigAdditionalDefination["SameLineServiceTypeLabour"] = "SameLineServiceType(Labour)";
    return RepeatAlertConfigAdditionalDefination;
}({});
export var RepeatAlertResolutionConfiguration = /*#__PURE__*/ function (RepeatAlertResolutionConfiguration) {
    RepeatAlertResolutionConfiguration["HeaderResolutionConfiguration"] = "HeaderResolutionConfiguration";
    RepeatAlertResolutionConfiguration["LineLevelLabourResolutionConfiguration"] = "LineLevelLabourResolutionConfiguration";
    RepeatAlertResolutionConfiguration["LineLevelPartResolutionConfiguration"] = "LineLevelPartResolutionConfiguration";
    RepeatAlertResolutionConfiguration["SameLineCustomerComplaint"] = "SameLineCustomerComplaint";
    return RepeatAlertResolutionConfiguration;
}({});
export var AlertFields = /*#__PURE__*/ function (AlertFields) {
    AlertFields["Reason"] = "Reason";
    AlertFields["RootCause"] = "RootCause";
    AlertFields["correctiveAction"] = "correctiveAction";
    AlertFields["Remark"] = "Remark";
    AlertFields["RootCauseCategory"] = "RootCauseCategory";
    return AlertFields;
}({});
// export const REPEAT_CONFIG = { // For CV //done
//     "_id": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "id": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "SchemaId": "10447355-a6e9-451e-89ad-f0c983d9a1c7",
//     "PartitionKey": "39e59d4c-070f-4566-af92-d4230836c0ec",
//     "CreatedOn": "2024-10-16T08:58:38.029Z",
//     "CreatedBy": "b5bfcc0c-182a-41c2-914e-06a5213fba0b",
//     "UpdatedOn": "2024-10-25T10:44:57.863Z",
//     "UpdatedBy": "b5bfcc0c-182a-41c2-914e-06a5213fba0b",
//     "_type": "RepeatRevisitAlertConfiguration",
//     "_ts": "2024-10-25T10:44:57.863Z",
//     "RepeatRevisitAlertConfigurationId": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "ChannelId": "5baacc2a-c9d5-4464-9cae-b16fd447ff06",
//     "ChannelPartnerId": "a85e0cf3-a8e9-41bb-a48e-3d23bbdf899b",
//     "EntityId": "5ea00d14-a3c4-4ccf-be85-2b04bbef57a1",
//     "TypeChildId": null,
//     "OrganizationId": "04945692-d924-4f9d-ae24-83b46eeb5867",
//     "IsRootConfiguration": true,
//     "Type": "Both",
//     "IsEnableAlert": true,
//     "Transaction": ["Inspection", "Estimate"],
//     "Configuration": [
//         {
//             "id": "278c47c2-7f7b-4e03-a025-1ec6da37ace4",
//             "Key": "KMs",
//             "Operator": "AND",
//             "Value": true,
//             "ConditionValue": "2000"
//         },
//         {
//             "Key": "Days",
//             "Operator": "AND",
//             "Value": true,
//             "ConditionValue": "30",
//             "id": "278c47c2-7f7b-4e03-a025-1ec6da37ace4"
//         },
//         {
//             "Key": "SameBranch",
//             "Operator": "AND",
//             "Value": true
//         }
//     ],
//     "AdditionalDefination": [
//         {
//             "Key": "SameLineServiceType(Labour)",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameLineServiceType(Part)",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameCustomerComplaint",
//             "Operator": "AND",
//             "Value": false,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameLabour",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameParts",
//             "Operator": "AND",
//             "Value": false,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         }
//     ],
//     "ResolutionConfiguration": [
//         {
//             "id": "107ffda3-889d-4526-a08d-d55ae667be0b",
//             "RepeatResolutionConfiguration": "Header Resolution Configuration",
//             "Key": "HeaderResolutionConfiguration",
//             "Reason": "Optional", //hide
//             "RootCause": "Optional", //hide
//             "correctiveAction": "Optional", //hide
//             "Remark": "Mandatory", //show // mandatory
//             "RootCauseCategory": "Optional" //hide
//         },
//         {
//             "id": "485b4355-a11b-4b36-b7c3-503423f4e4bb",
//             "RepeatResolutionConfiguration": "Line Level Labour Resolution Configuration",
//             "Key": "LineLevelLabourResolutionConfiguration",
//             "Reason": "Mandatory",  //show // mandatory
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //show // optional
//             "RootCauseCategory": "Optional"//hide
//         },
//         {
//             "id": "8850c5a0-e03a-41f7-aac0-326fcb2d6f23",
//             "RepeatResolutionConfiguration": "Line Level part Resolution Configuration",
//             "Key": "LineLevelPartResolutionConfiguration",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide
//             "RootCauseCategory": "Optional"//hide
//         },
//         {
//             "id": "972caa40-d37f-49ad-95c4-97710adeb00d",
//             "RepeatResolutionConfiguration": "Same Line customer Complaint",
//             "Key": "SameLineCustomerComplaint",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide
//             "RootCauseCategory": "Optional"//hide
//         }
//     ],
//     "IsActive": true,
//     "IsDeleted": false
// }
// export const REPEAT_CONFIG = { // For MC /done
//     "_id": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "id": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "SchemaId": "10447355-a6e9-451e-89ad-f0c983d9a1c7",
//     "PartitionKey": "39e59d4c-070f-4566-af92-d4230836c0ec",
//     "CreatedOn": "2024-10-16T08:58:38.029Z",
//     "CreatedBy": "b5bfcc0c-182a-41c2-914e-06a5213fba0b",
//     "UpdatedOn": "2024-10-25T10:44:57.863Z",
//     "UpdatedBy": "b5bfcc0c-182a-41c2-914e-06a5213fba0b",
//     "_type": "RepeatRevisitAlertConfiguration",
//     "_ts": "2024-10-25T10:44:57.863Z",
//     "RepeatRevisitAlertConfigurationId": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "ChannelId": "5baacc2a-c9d5-4464-9cae-b16fd447ff06",
//     "ChannelPartnerId": "a85e0cf3-a8e9-41bb-a48e-3d23bbdf899b",
//     "EntityId": "5ea00d14-a3c4-4ccf-be85-2b04bbef57a1",
//     "TypeChildId": null,
//     "OrganizationId": "04945692-d924-4f9d-ae24-83b46eeb5867",
//     "IsRootConfiguration": true,
//     "Type": "Both",
//     "IsEnableAlert": true,
//     "Transaction": ["Inspection", "Estimate"],
//     "Configuration": [
//         {
//             "id": "278c47c2-7f7b-4e03-a025-1ec6da37ace4",
//             "Key": "KMs",
//             "Operator": "AND",
//             "Value": true,
//             "ConditionValue": "2000"
//         },
//         {
//             "Key": "Days",
//             "Operator": "AND",
//             "Value": true,
//             "ConditionValue": "30",
//             "id": "278c47c2-7f7b-4e03-a025-1ec6da37ace4"
//         },
//         {
//             "Key": "SameBranch",
//             "Operator": "AND",
//             "Value": true
//         }
//     ],
//     "AdditionalDefination": [
//         {
//             "Key": "SameLineServiceType(Labour)",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameLineServiceType(Part)",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameCustomerComplaint",
//             "Operator": "AND",
//             "Value": false,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameLabour",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameParts",
//             "Operator": "AND",
//             "Value": false,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         }
//     ],
//     "ResolutionConfiguration": [
//         {
//             "id": "107ffda3-889d-4526-a08d-d55ae667be0b",
//             "RepeatResolutionConfiguration": "Header Resolution Configuration",
//             "Key": "HeaderResolutionConfiguration",
//             "Reason": "Optional", //hide
//             "RootCause": "Optional", //hide
//             "correctiveAction": "Optional", //hide
//             "Remark": "Mandatory", //show // mandatory
//             "RootCauseCategory": "Optional" //hide
//         },
//         {
//             "id": "485b4355-a11b-4b36-b7c3-503423f4e4bb",
//             "RepeatResolutionConfiguration": "Line Level Labour Resolution Configuration",
//             "Key": "LineLevelLabourResolutionConfiguration",
//             "Reason": "Mandatory",  //show // mandatory
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide // optional
//             "RootCauseCategory": "Optional"//hide
//         },
//         {
//             "id": "8850c5a0-e03a-41f7-aac0-326fcb2d6f23",
//             "RepeatResolutionConfiguration": "Line Level part Resolution Configuration",
//             "Key": "LineLevelPartResolutionConfiguration",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide
//             "RootCauseCategory": "Optional"//hide
//         },
//         {
//             "id": "972caa40-d37f-49ad-95c4-97710adeb00d",
//             "RepeatResolutionConfiguration": "Same Line customer Complaint",
//             "Key": "SameLineCustomerComplaint",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide
//             "RootCauseCategory": "Optional"//hide
//         }
//     ],
//     "IsActive": true,
//     "IsDeleted": false
// }
// export const REPEAT_CONFIG = { // For PB
//     "_id": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "id": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "SchemaId": "10447355-a6e9-451e-89ad-f0c983d9a1c7",
//     "PartitionKey": "39e59d4c-070f-4566-af92-d4230836c0ec",
//     "CreatedOn": "2024-10-16T08:58:38.029Z",
//     "CreatedBy": "b5bfcc0c-182a-41c2-914e-06a5213fba0b",
//     "UpdatedOn": "2024-10-25T10:44:57.863Z",
//     "UpdatedBy": "b5bfcc0c-182a-41c2-914e-06a5213fba0b",
//     "_type": "RepeatRevisitAlertConfiguration",
//     "_ts": "2024-10-25T10:44:57.863Z",
//     "RepeatRevisitAlertConfigurationId": "ff1a26eb-151d-4584-8d23-a45dff566984",
//     "ChannelId": "5baacc2a-c9d5-4464-9cae-b16fd447ff06",
//     "ChannelPartnerId": "a85e0cf3-a8e9-41bb-a48e-3d23bbdf899b",
//     "EntityId": "5ea00d14-a3c4-4ccf-be85-2b04bbef57a1",
//     "TypeChildId": null,
//     "OrganizationId": "04945692-d924-4f9d-ae24-83b46eeb5867",
//     "IsRootConfiguration": true,
//     "Type": "Both",
//     "IsEnableAlert": true,
//     "Transaction": ["Inspection", "Estimate"],
//     "Configuration": [
//         {
//             "id": "278c47c2-7f7b-4e03-a025-1ec6da37ace4",
//             "Key": "KMs",
//             "Operator": "AND",
//             "Value": true,
//             "ConditionValue": "2000"
//         },
//         {
//             "Key": "Days",
//             "Operator": "AND",
//             "Value": true,
//             "ConditionValue": "30",
//             "id": "278c47c2-7f7b-4e03-a025-1ec6da37ace4"
//         },
//         {
//             "Key": "SameBranch",
//             "Operator": "AND",
//             "Value": true
//         }
//     ],
//     "AdditionalDefination": [
//         {
//             "Key": "SameLineServiceType(Labour)",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameLineServiceType(Part)",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameCustomerComplaint",
//             "Operator": "AND",
//             "Value": false,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameLabour",
//             "Operator": "AND",
//             "Value": true,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         },
//         {
//             "Key": "SameParts",
//             "Operator": "AND",
//             "Value": false,
//             "id": "605314e8-6280-4d03-85b4-24b63a03ba1a"
//         }
//     ],
//     "ResolutionConfiguration": [
//         {
//             "id": "107ffda3-889d-4526-a08d-d55ae667be0b",
//             "RepeatResolutionConfiguration": "Header Resolution Configuration",
//             "Key": "HeaderResolutionConfiguration",
//             "Reason": "Mandatory",  //show // mandatory
//             "RootCause": "Mandatory",  //show // mandatory
//             "correctiveAction": "Optional",//hide
//             "Remark": "Mandatory",  //show // mandatory
//             "RootCauseCategory": "Mandatory",  //show // mandatory
//         },
//         {
//             "id": "485b4355-a11b-4b36-b7c3-503423f4e4bb",
//             "RepeatResolutionConfiguration": "Line Level Labour Resolution Configuration",
//             "Key": "LineLevelLabourResolutionConfiguration",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //show
//             "RootCauseCategory": "Optional"//hide
//         },
//         {
//             "id": "8850c5a0-e03a-41f7-aac0-326fcb2d6f23",
//             "RepeatResolutionConfiguration": "Line Level part Resolution Configuration",
//             "Key": "LineLevelPartResolutionConfiguration",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide
//             "RootCauseCategory": "Optional"//hide
//         },
//         {
//             "id": "972caa40-d37f-49ad-95c4-97710adeb00d",
//             "RepeatResolutionConfiguration": "Same Line customer Complaint",
//             "Key": "SameLineCustomerComplaint",
//             "Reason": "Optional",//hide
//             "RootCause": "Optional",//hide
//             "correctiveAction": "Optional",//hide
//             "Remark": "Optional",  //hide
//             "RootCauseCategory": "Optional"//hide
//         }
//     ],
//     "IsActive": true,
//     "IsDeleted": false
// }
export var REPEAT_SHOW_HIDE_CONFIG_CV = {
    //done
    HEADER_LEVEL: {
        "Reason": false,
        //hide
        "RootCause": false,
        //hide
        "correctiveAction": false,
        //hide
        "Remark": true,
        //show // mandatory
        "RootCauseCategory": false //hide
    },
    LINE_LEVEL: {
        "Reason": true,
        //show // mandatory
        "RootCause": false,
        //hide
        "correctiveAction": false,
        //hide
        "Remark": true,
        //show // optional
        "RootCauseCategory": false //hide
    }
};
export var REPEAT_SHOW_HIDE_CONFIG_MC = {
    // done
    HEADER_LEVEL: {
        "Reason": false,
        //hide
        "RootCause": false,
        //hide
        "correctiveAction": false,
        //hide
        "Remark": true,
        //show // mandatory
        "RootCauseCategory": false //hide
    },
    LINE_LEVEL: {
        "Reason": true,
        //show // mandatory
        "RootCause": false,
        //hide
        "correctiveAction": false,
        //hide
        "Remark": false,
        //hide
        "RootCauseCategory": false //hide
    }
};
export var REPEAT_SHOW_HIDE_CONFIG_PB = {
    //done
    HEADER_LEVEL: {
        "Reason": true,
        //show // mandatory
        "RootCause": true,
        //show // mandatory
        "correctiveAction": false,
        //hide
        "Remark": true,
        //show // mandatory
        "RootCauseCategory": true //show // mandatory
    },
    LINE_LEVEL: {
        "Reason": true,
        //show //optional
        "RootCause": false,
        //hide
        "correctiveAction": false,
        //hide
        "Remark": true,
        //show // optional
        "RootCauseCategory": false //hide
    }
};
export var E_Channel_Name = /*#__PURE__*/ function (E_Channel_Name) {
    E_Channel_Name["CV"] = "CV";
    E_Channel_Name["MC"] = "MC";
    E_Channel_Name["PB"] = "PB";
    E_Channel_Name["Triumph"] = "Triumph";
    return E_Channel_Name;
}({});
export var dateBeforeWeek = dayjs().subtract(7, 'day');
export var dateBeforeMonth = dayjs().subtract(30, 'day');
// this flags are only for the MixPanel because it has events limit.
export var mixPanelEventConstants = {
    ButtonClickEvents: true,
    APICallEvents: false,
    ErrorLogEvents: true,
    APICallGreaterThan5mb: false,
    // If APICallEvents is true then only this will work
    CliendSideError: false // If ErrorLogEvents is true then only this will work
};
export var EContactType = {
    Primary: "Primary",
    Secondary: "Secondary"
};
export var Analytics = {
    MixPanel: false,
    // any one analytic should be true for log events
    GA: false // any one analytic should be true for log events
};
export var SERVICE_TYPE_ERROR_CODE = "ERR_GO0003";
;
export var accidentalDetailsFields = ["AccidentDateTime", "IntimationDateTime", "LocationOfAccident", "NatureOfAccident", "DamageDescription", "Attachments", "AccidentReportNumber", "DriverName"];
export var insuranceDetailsFields = ["InsuranceProviderName", "PolicyNumber", "PolicyHolderName", "InsuredName", "CoverageType", "LossType", "SurveyorName", "SurveyorNumber", "InsurancePolicyExpiryDate"];
